// extracted by mini-css-extract-plugin
module.exports = {"search":"Search__search","label":"Search__label","submitButton":"Search__submitButton","globalSearch":"Search__globalSearch","loadingSpinner":"Search__loadingSpinner"};